/* @flow */

import * as React from 'react';
import { withHandlers } from 'recompose';
import glamorous from 'glamorous';
import { size as boxSize } from 'polished';
import { hover } from 'app/utils/cssUtils';
import Tappable from 'app/components/commons/Tappable';

type Props = {
  checked?: boolean,
  children?: any,
  className?: string,
  labelFirst?: boolean,
  uppercase?: boolean,
  onChange: () => void,
  required?: boolean
};

const defaultProps = {
  checked: false,
  className: undefined,
  uppercase: true,
  children: undefined,
  labelFirst: false,
  required: false
};

const CheckboxWrapper = glamorous.div({
  alignItems: 'center',
  display: 'flex',
  transition: 'color 0.2s',
  ...hover({
    opacity: 0.8
  })
});

const CheckboxIcon = glamorous.span({
  alignItems: 'center',
  borderRadius: 2,
  borderStyle: 'solid',
  borderWidth: 2,
  ...boxSize('1.25em'),
  display: 'flex',
  justifyContent: 'center',
  transition: 'color 0.2s'
});

const Checkmark = glamorous.div(({ theme }) => ({
  alignItems: 'center',
  color: theme.color.primary,
  display: 'flex',
  justifyContent: 'center',
  '&::after': {
    content: '"\\2713"'
  }
}));

const Label = glamorous.span(({ position, required, theme, uppercase }) => ({
  paddingTop: 2,
  paddingRight: position === 'left' ? 5 : 0,
  paddingBottom: 2,
  paddingLeft: position === 'right' ? 5 : 0,
  textTransform: uppercase ? 'uppercase' : 'none',
  transition: 'color 0.2s',
  '&::after': required
    ? {
        color: theme.color.danger,
        content: '" *"'
      }
    : undefined
}));

function Checkbox({ checked, className, children, labelFirst, onChange, required, uppercase }: Props) {
  return (
    <Tappable component={CheckboxWrapper} checked={checked} className={className} onTap={onChange}>
      {labelFirst && (
        <Label position="left" required={required} uppercase={uppercase}>
          {children}
        </Label>
      )}
      <CheckboxIcon>{checked && <Checkmark />}</CheckboxIcon>
      {!labelFirst && (
        <Label position="right" required={required} uppercase={uppercase}>
          {children}
        </Label>
      )}
    </Tappable>
  );
}

Checkbox.defaultProps = defaultProps;

const enhancer = withHandlers({
  onChange: ({ checked, onChange }) => () => {
    onChange(!checked);
  }
});

export default enhancer(Checkbox);
